var map = {
	"./ar-privacy-policy.html": "./src/locales/privacy-policy/ar-privacy-policy.html",
	"./de-privacy-policy.html": "./src/locales/privacy-policy/de-privacy-policy.html",
	"./en-privacy-policy.html": "./src/locales/privacy-policy/en-privacy-policy.html",
	"./es-privacy-policy.html": "./src/locales/privacy-policy/es-privacy-policy.html",
	"./fr-privacy-policy.html": "./src/locales/privacy-policy/fr-privacy-policy.html",
	"./it-privacy-policy.html": "./src/locales/privacy-policy/it-privacy-policy.html",
	"./ro-privacy-policy.html": "./src/locales/privacy-policy/ro-privacy-policy.html"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales/privacy-policy sync recursive ^\\.\\/.*\\-privacy\\-policy\\.html$";